//------------------
// get race details
//------------------
export default function getRaceDetails(race, objArray) {
  let details = objArray.find((a) => a.name == race);
  return details;
}
